import { render, staticRenderFns } from "./T-F-Grad-2024-CN.vue?vue&type=template&id=537c5a4e&scoped=true"
import script from "./T-F-Grad-2024-CN.vue?vue&type=script&lang=js"
export * from "./T-F-Grad-2024-CN.vue?vue&type=script&lang=js"
import style0 from "./T-F-Grad-2024-CN.vue?vue&type=style&index=0&id=537c5a4e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537c5a4e",
  null
  
)

export default component.exports